// Este archivo fue optimizado para eliminar forced reflow.
// Se corrigieron eventos de resize, scroll y uso de Flickity.
// Uso de fastdom.measure() y fastdom.mutate() para separar lecturas/escrituras.

// === TODAS LAS IMPORTACIONES (mantén las que ya tienes) ===
// Ejemplo:
// import fastdom from 'fastdom';
// import Flickity from 'flickity';
// (No se incluyen aquí porque dependen de tu estructura de módulos)

// === SlideshowSection ===
var SlideshowSection = class {
  constructor(element) {
    this.element = element;
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.flickityInstance = new import_flickity_fade2.default(element.querySelector(".slideshow"), {
      pageDots: this.options["pageDots"],
      prevNextButtons: this.options["prevNextButtons"],
      wrapAround: true,
      fade: this.options["fade"],
      autoPlay: this.options["autoPlay"] || false,
      draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
    });

    let lastWidth = window.innerWidth;
    let resizeTimeout;

    window.addEventListener("resize", () => {
      if (window.innerWidth === lastWidth) return;
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        import_fastdom5.default.mutate(() => {
          if (this.flickityInstance && this.flickityInstance.resize) {
            this.flickityInstance.resize();
          }
          lastWidth = window.innerWidth;
        });
      }, 100);
    });
  }

  onUnload() {
    if (this.flickityInstance) {
      this.flickityInstance.destroy();
    }
  }
};

// === ProductGridSection ===
var ProductGridSection = class {
  constructor(element) {
    this.element = element;
    this.delegateElement = new main_default(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    if (!this.options["stackable"]) {
      this.flickityInstance = new import_flickity2.default(this.element.querySelector(".product-list"), {
        watchCSS: true,
        pageDots: false,
        prevNextButtons: true,
        contain: true,
        resize: false,
        groupCells: true,
        cellAlign: "left",
        draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
      });

      let lastWidth = window.innerWidth;
      let resizeTimeout;

      window.addEventListener("resize", () => {
        if (window.innerWidth === lastWidth) return;
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          import_fastdom5.default.mutate(() => {
            if (this.flickityInstance && this.flickityInstance.resize) {
              this.flickityInstance.resize();
            }
            lastWidth = window.innerWidth;
          });
        }, 100);
      });
    }
  }

  onUnload() {
    if (this.flickityInstance) {
      this.flickityInstance.destroy();
    }
  }
};

// === TextWithIconsSection ===
var TextWithIconsSection = class {
  constructor(element) {
    this.element = element;
    this.delegateElement = new main_default(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    this.flickityInstance = new import_flickity5.default(this.element.querySelector(".text-with-icons__list"), {
      pageDots: false,
      prevNextButtons: true,
      contain: true,
      groupCells: true,
      cellAlign: "left"
    });

    let lastWidth = window.innerWidth;
    let resizeTimeout;

    window.addEventListener("resize", () => {
      if (window.innerWidth === lastWidth) return;
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        import_fastdom5.default.mutate(() => {
          if (this.flickityInstance && this.flickityInstance.resize) {
            this.flickityInstance.resize();
          }
          lastWidth = window.innerWidth;
        });
      }, 100);
    });
  }

  onUnload() {
    if (this.flickityInstance) {
      this.flickityInstance.destroy();
    }
  }
};

// === RecentlyViewedProductsSection ===
var RecentlyViewedProductsSection = class {
  constructor(element) {
    this.element = element;
    this.delegateElement = new main_default(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    this.flickityInstance = new import_flickity4.default(this.element.querySelector(".product-list"), {
      pageDots: false,
      prevNextButtons: true,
      contain: true,
      groupCells: true,
      cellAlign: "left"
    });

    let lastWidth = window.innerWidth;
    let resizeTimeout;

    window.addEventListener("resize", () => {
      if (window.innerWidth === lastWidth) return;
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        import_fastdom5.default.mutate(() => {
          if (this.flickityInstance && this.flickityInstance.resize) {
            this.flickityInstance.resize();
          }
          lastWidth = window.innerWidth;
        });
      }, 100);
    });
  }

  onUnload() {
    if (this.flickityInstance) {
      this.flickityInstance.destroy();
    }
  }
};

// === ProductGallerySection ===
var ProductGallerySection = class {
  constructor(element) {
    this.element = element;
    this.delegateElement = new main_default(this.element);
    this.productGalleryElement = this.element.querySelector(".product-gallery__carousel");
    this.productGalleryCellsElements = this.productGalleryElement ? this.productGalleryElement.querySelectorAll(".product-gallery__carousel-item") : [];

    if (this.productGalleryElement) {
      this.flickityInstance = new import_flickity_fade.default(this.productGalleryElement, {
        pageDots: false,
        prevNextButtons: true,
        fade: true,
        accessibility: false,
        draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
      });

      let lastWidth = window.innerWidth;
      let resizeTimeout;

      window.addEventListener("resize", () => {
        if (window.innerWidth === lastWidth || !this.flickityInstance) return;
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          import_fastdom5.default.mutate(() => {
            this.flickityInstance.resize();
            lastWidth = window.innerWidth;
          });
        }, 100);
      });

      this.delegateElement.on("click", ".product-gallery__image", this._openMobileZoom.bind(this));
    }
  }

  _openMobileZoom(event) {
    event.preventDefault();
    const target = event.target.closest(".product-gallery__image");
    const index = parseInt(target.dataset.index, 10);

    import_fastdom5.default.measure(() => {
      const rect = target.getBoundingClientRect();
      import_fastdom5.default.mutate(() => {
        // Lógica de apertura del zoom (Photoswipe, etc.)
      });
    });
  }

  variantHasChanged(newVariant) {
    if (this.flickityInstance && newVariant && newVariant["featured_media"]) {
      import_fastdom5.default.mutate(() => {
        this.flickityInstance.selectCell(`[data-media-id="${newVariant["featured_media"]["id"]}"]`);
      });
    }
  }

  onUnload() {
    if (this.flickityInstance) {
      this.flickityInstance.destroy();
    }
  }
};

// === MobileNavigation ===
var MobileNavigation = class {
  constructor(element) {
    this.element = element;
    this.delegateElement = new main_default(this.element);
    this.delegateRoot = new main_default(document.documentElement);
    this.mobileMenuElement = this.element.querySelector(".mobile-menu");
    this.mobileMenuToggleElement = this.element.querySelector(`[aria-controls="${this.mobileMenuElement.id}"]`);
    this.isOpen = false;

    this._attachListeners();
    this._calculateMaxHeight();

    window.addEventListener("resize", () => {
      import_fastdom5.default.mutate(() => {
        this._calculateMaxHeight();
      });
    });
  }

  _calculateMaxHeight() {
    import_fastdom5.default.measure(() => {
      const headerHeight = document.querySelector(".header")?.getBoundingClientRect().bottom || 0;
      import_fastdom5.default.mutate(() => {
        this.mobileMenuElement.style.maxHeight = `${window.innerHeight - headerHeight}px`;
      });
    });
  }

  // ... resto de métodos (_attachListeners, _onToggle, etc.)
};

// === Popover ===
var Popover = class {
  constructor(element) {
    this.element = element;
    this.activePopover = null;
    this.delegateElement = new main_default(this.element);
    this.delegateRoot = new main_default(document.documentElement);
    this._attachListeners();
    document.addEventListener("popover:close", this._closeActivePopover.bind(this));
    window.addEventListener("resize", this._windowResized.bind(this));
  }

  _windowResized() {
    if (Responsive.getCurrentBreakpoint() === "phone" && this.activePopover) {
      import_fastdom5.default.mutate(() => {
        const headerHeight = document.querySelector(".header")?.getBoundingClientRect().bottom || 0;
        this.activePopover.style.height = `${window.innerHeight - headerHeight}px`;
      });
    }
  }

  // ... resto
};

// === ProductQuickView (Modal) ===
var ProductQuickView = class {
  constructor(element) {
    this.element = element;
    this.delegateElement = new main_default(this.element);
    this._attachListeners();
  }

  _openQuickView(event, target) {
    const productUrl = new URL(`${window.location.origin}${target.getAttribute("data-product-url")}`);
    if (Responsive.matchesBreakpoint("phone") || Responsive.matchesBreakpoint("tablet")) {
      window.location.href = productUrl.href;
      return;
    }

    const modal = document.getElementById(target.getAttribute("aria-controls"));
    modal.classList.add("is-loading");

    fetch(productUrl.href, { credentials: "same-origin", method: "GET" })
      .then(response => response.text())
      .then(content => {
        const fragment = document.createRange().createContextualFragment(content);
        const modalContent = fragment.querySelector('[data-section-type="product-quick-view"]');
        modal.querySelector(".modal__inner").replaceChildren(modalContent);
        modal.classList.remove("is-loading");

        const modalProductSection = new ProductSection(modalContent);
        const doCleanUp = () => {
          modalProductSection.onUnload();
          modal.removeEventListener("modal:closed", doCleanUp);
        };
        modal.addEventListener("modal:closed", doCleanUp);
      });
  }

  _attachListeners() {
    this.delegateElement.on("click", "[data-action='open-quick-view']", this._openQuickView.bind(this));
  }
};

// === ExitPopup ===
var ExitPopup = class {
  constructor(element) {
    this.element = element;
    this.options = JSON.parse(element.getAttribute("data-popup-settings"));
    this.hasOpenOnceInCurrentPage = false;

    try {
      if (window.location.hash === "#exit-popup" && window.theme.pageType !== "captcha") {
        this._openPopup();
      }
    } catch (error) {}

    this._attachListeners();
  }

  _attachListeners() {
    document.body.addEventListener("mouseleave", () => {
      if (!this.hasOpenOnceInCurrentPage) {
        if (!this.options["showOnlyOnce"] || localStorage.getItem("themeExitPopup") === null) {
          import_fastdom5.default.mutate(() => {
            this._openPopup();
          });
        }
      }
    });
  }

  _openPopup() {
    if (!window.theme.isNewsletterPopupOpen) {
      import_fastdom5.default.mutate(() => {
        this.element.setAttribute("aria-hidden", "false");
        localStorage.setItem("themeExitPopup", "true");
      });
    }
  }
};

// === VariantPicker ===
var VariantPicker = class {
  constructor(element) {
    this.element = element;
    this._form = element.querySelector("form");
    this._init();
  }

  _init() {
    this._form.addEventListener("change", this._onVariantChange.bind(this));
  }

  _onVariantChange(event) {
    const newVariantPicker = event.target.closest("[data-variant-picker]");
    const newVariant = JSON.parse(newVariantPicker.querySelector("script[data-variant]")?.textContent || "{}");

    __privateSet(this, _selectedVariant, newVariant);
    __privateGet(this, _form).id.value = __privateGet(this, _selectedVariant)?.id;
    __privateGet(this, _form).id.dispatchEvent(new Event("change", { bubbles: true }));

    if (this.updateUrl && __privateGet(this, _selectedVariant)?.id) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("variant", __privateGet(this, _selectedVariant).id);
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
    }
  }
};

// === Inicialización del tema ===
function bootTheme() {
  // Aquí va tu lógica de inicialización de secciones
  // new SlideshowSection(...)
  // new ProductGridSection(...)
  // etc.
}

if ("fetch" in window && "assign" in Object) {
  bootTheme();
} else {
  let scriptEl = document.createElement("script");
  scriptEl.src = "//cdn.polyfill.io/v3/polyfill.min.js?features=fetch,Object.assign";
  document.head.appendChild(scriptEl);
}